<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item fn-clear">
        <select-box class="fn-left" :selects="selects" :post-form.sync="listQuery" @search="$refs.couponlisttable.fetchTableData()" />
        <el-button style="padding: 10px 20px;" class="fn-right" type="success" @click="fnCreate()">新建优惠券</el-button>
      </div>
    </div>
    <div class="tuolele-main-box">
      <el-button style="padding: 10px 20px;margin-bottom: 10px;" class="fn-right" type="success" @click="fnExportSended()">导出已发放优惠券</el-button>
      <wq-table ref="couponlisttable" show-page sub-key="list" :other-query="listQuery" :url-func="$http.getCouponList">
        <el-table-column prop="id" label="优惠券ID" />
        <el-table-column prop="coupon_name" label="优惠券名称" />
        <el-table-column prop="deductible_amount" label="价值" width="150">
          <template slot-scope="scope">
            <span><span>￥</span>{{ scope.row.deductible_amount/100 || 0 }}</span><span v-if="scope.row.rule_amount>0">(满{{ scope.row.rule_amount/100 || 0 }})</span>
          </template>
        </el-table-column>
        <el-table-column prop="coupon_desc" label="说明" />
        <el-table-column prop="limited_number" label="发行张数" />
        <el-table-column prop="quantity_issued" label="已发放">
          <template slot-scope="scope">
            <el-button type="text" @click="fnHistory(scope.row, 'send')">{{ scope.row.quantity_issued || 0 }}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="used_count" label="已使用">
          <template slot-scope="scope">
            <el-button type="text" @click="fnHistory(scope.row, 'used')">{{ scope.row.used_count || 0 }}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="start_time" label="开始时间" />
        <el-table-column prop="end_time" label="结束时间" />
        <!-- <el-table-column prop="shop_name" label="是否允许叠加" /> -->
        <el-table-column prop="status_name" label="状态" />
        <el-table-column prop="shop_names" show-overflow-tooltip label="可使用店铺" />

        <el-table-column prop="shop_name" label="操作" width="150">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="fnSetStatus(scope.row)">{{ scope.row.status == 1 ? '停用' : '启用' }}</el-button>
            <el-button size="mini" style="color: #E6A23C !important;" type="text" v-if="scope.row.status==1" @click="fnSend(scope.row)">发放</el-button>
            <el-button size="mini" style="color: #f56c6c !important;" type="text" @click="fnDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </wq-table>
      <el-dialog :visible.sync="bShowFormBoxDialog" width="600px" title="发放优惠券">
        <form-box position="top" :forms="forms" :post-form="sendPostForm" @submit="fnSendSubmit" />
      </el-dialog>
      <el-dialog :visible.sync="showHistoryDialog" width="600px" :title="`${currentCouponType == 'send' ? '已发放' : '已使用'}优惠券`">
        <div v-for="(item,couponIndex) in couponHistory[currentCouponType]" :key="item.master_id" class="student_main_box" style="margin-bottom: 10px;">
          <div class="wq_flex">
            <div class="student_tips wq_flex_sub">同一家长共同使用(ID:{{ item.id }})</div>
            <div class="wq_text_danger" @click="fnDeleteChildCoupon(item.id,couponIndex)">删除</div>
          </div>

          <div class="student_info_box">
            <div class="wq_flex">
              <div class="wq_flex_sub">学员长ID</div>
              <div>学员姓名</div>
            </div>
            <div v-for="sub in item.student_info" :key="sub.sub_id" class="wq_flex">
              <div class="wq_flex_sub">{{ sub.sub_id }}</div>
              <div>{{ sub.sub_name }}</div>
            </div>
          </div>
        </div>
        <div v-if="couponHistory[currentCouponType].length == 0" class="student_main_box" style="text-align: center; padding: 20px;">暂无数据</div>
      </el-dialog>
    </div>

  </div>
</template>
<script>

import FormBox from '@/components/FormBox'
import SelectBox from '@/components/SelectBox'
import WqTable from '@/components/WqTable'

const defaultSearchPostForm = {
  coupon_name: ''
}
const defaultSendPostForm = {
  sub_id: '',
  coupon_id: ''
}

export default {
  name: 'TurnStudentList',
  components: {
    // Select
    WqTable,
    SelectBox,
    FormBox
  },

  data() {
    return {
      lists: [],
      selects: [
        { type: 'input', bindValue: 'coupon_name', placeholder: '优惠券名称' }
      ],
      couponHistory: {
        send: [],
        used: []
      },
      currentCouponType: 'send',
      showHistoryDialog: false,
      sendPostForm: Object.assign({}, defaultSendPostForm),
      forms: [
        { type: 'textarea', bindValue: 'sub_id', label: '学员长ID', rows: 10, require: true, tips: '学员长ID, 英语逗号分隔<div style="line-height:12px">优惠卷是发送到家长账号中，如果家长有多个孩子，可以共享使用</div>' }],
      listQuery: Object.assign({}, defaultSearchPostForm),
      bShowFormBoxDialog: false
    }
  },
  created() {
  },
  methods: {
    fnDelete(row) {
      this.$confirm('是否删除该优惠券？', '提示', {
        type: 'warning'
      }).then(() => {
        this.$http.removeCoupon({ id: row.id }).then(res => {
          if (res.code === 200) {
            this.$message({
              message: '优惠券删除成功',
              type: 'success'
            })
            this.$refs.couponlisttable.fetchTableData()
            return
          }
        })
      })
    },
    fnCreate() {
      this.$router.push({ path: '/admin/discount/createCoupon' })
    },
    fnSetStatus(row) {
      var msg = row.status === '0' ? '确定启用“'+row.coupon_name+'”么？' : '停用会删除所有已发送未使用的学生优惠券，是否确认停用？';
        this.$confirm(msg, '提示', {
        type: 'warning'
      }).then(() => {
          this.$http.openCloseCoupon({ id: row.id, status: row.status === '0' ? '1' : '0' }).then(res => {
                  if (res.code === 200) {
                    this.$message({
                      message: '操作成功',
                      type: 'success'
                    })
                    this.$refs.couponlisttable.fetchTableData()
                    return
                  }
                })
            })
     
    },
    fnDeleteChildCoupon(id, index) {
      this.$confirm('是否删除该优惠券？', '提示', {
        type: 'warning'
      }).then(() => {
        this.$http.delUserCoupon({ id }).then(res => {
          if (res.code === 200) {
            this.$message({
              message: '优惠券删除成功',
              type: 'success'
            })
            this.couponHistory[this.currentCouponType].splice(index, 1)
            return
          }
        })
      })
    },
    fnSend(row) {
      this.sendPostForm = Object.assign({}, defaultSendPostForm, { coupon_id: row.id })
      this.bShowFormBoxDialog = true
    },
    fnExportSended() {
      const url = process.env.VUE_APP_BASE_URL
      var reportUrl = `${url}/Exceldownload/download?id=cms_5`
      window.open(reportUrl)
    },
    fnSendSubmit(postForm) {
      this.$http.distributeCoupons(postForm).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '优惠券发放成功',
            type: 'success'
          })
          this.bShowFormBoxDialog = false
          this.$refs.couponlisttable.fetchTableData()
          return
        }
      })
    },
    async fnHistory(row, type) {
      const res = await this.$http.getCouponUseList({ type: type, coupon_id: row.id })
      this.couponHistory[type] = res.data.list
      this.currentCouponType = type
      this.showHistoryDialog = true
    }

    // fnUpdate(row) {
    //   this.$router.push({ path: '/admin/discount/createCoupon', query: { ...row }})
    // }
  }
}
</script>

<style lang="scss" scoped>

  .el-dropdown-link {
    font-size: 1em;
    font-weight: 500;
  }
  .student_main_box {
    padding: 10px;
    margin-bottom: 10px;
    border: 1px solid #dcdfe6;
  }

  .student_tips {
    color:#999999
  }

</style>

<style lang="scss">
.wq_flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}

.wq_flex_wrap {
  flex-wrap: wrap;
}

.wq_text_danger {
  color: #f56c6c;
  cursor: pointer;
}

.wq_flex_sub {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}

.el-image-viewer__wrapper .el-icon-circle-close {
  color:white
}
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
